<template>
  <div v-if="!giveawayExpired" class="giveaway">
    <div class="giveaway__image-container">
      <img
        :src="data.imageUrl"
        alt=""
        class="giveaway__image"
        loading="lazy"
      >
    </div>
    <giveaway-success
      v-if="showSuccess"
      :giveaway-details="data.ctaLink"
    />
    <giveaway-oops
      v-else-if="showDuplicateEntryScreen"
      :giveaway-details="data.ctaLink"
    />
    <div
      v-else
      class="giveaway__content-container"
    >
      <h2 class="giveaway__heading heading--3">
        It's Giveaway Time!
      </h2>
      <p
        class="giveaway__copy"
        v-html="helperCopy"
      />
      <giveaway-form
        :data="data"
        @submitted="changeScreens"
      />
    </div>
  </div>
</template>

<script>
import GiveawayForm from '@/components/EngagementToolkit/GiveawayForm.vue';
import GiveawaySuccess from '@/components/EngagementToolkit/GiveawaySuccess.vue';
import GiveawayOops from '@/components/EngagementToolkit/GiveawayOops.vue';

export default {
  name: 'Giveaway',
  components: {
    GiveawayForm,
    GiveawaySuccess,
    GiveawayOops,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showSuccess: false,
      showDuplicateEntryScreen: false,
    };
  },
  computed: {
    helperCopy() {
      const siteDomainLowercase = this.$site.name.toLowerCase();
      const currentFullUrl = `https://${siteDomainLowercase}${this.$route.fullPath}`;
      if (currentFullUrl !== this.data?.ctaLink) {
        return `${this.data.answerDescription}
        Get more details about the giveaway <a href="${this.data?.ctaLink}">here</a>.`;
      }
      return this.data?.answerDescription;
    },
    expirationDate() {
      const expirationDate = new Date(this.data.date);
      const currentOffset = new Date().getTimezoneOffset();
      const isDST = currentOffset === 240;
      expirationDate.setUTCHours(isDST ? 4 : 5, 0, 0, 0);
      return expirationDate;
    },
    giveawayExpired() {
      return this.expirationDate < new Date();
    },
  },
  methods: {
    changeScreens(type) {
      if (type === 'duplicateEntry') {
        this.showDuplicateEntryScreen = true;
      } else {
        this.showSuccess = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_giveaway';
</style>
